<template>
  <Login
    v-model:correo="correo"
    v-model:password="password"
    :error-correo="errorCorreo"
    :correo-invalido="correoInvalido"
    :error-password="errorPassword"
    @submit="autentificarUsuario()"
  />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import api from "@/servicios/apiCliente";
import { EstadoRespuesta, Core } from "@/servicios/api";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import { useStore } from "@/store";
import { useStore as useClienteClienteStore } from "../store";
import Login from "../components/Login/Login.vue";
const $router = useRouter();

//#region Data
const store = useClienteClienteStore();
const $store = useStore();
const correo = ref("");
const password = ref("");
const errorCorreo = ref(undefined as string | undefined);
const errorPassword = ref(undefined as string | undefined);
const correoInvalido = ref(false);
const contador = ref(0);
const PATRON_CORREO = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
//#endregion

//#region Methods

/** Valida el formato antes de llamar al servicio. */
function validarFormulario() {
  errorCorreo.value = undefined;
  errorPassword.value = undefined;
  correoInvalido.value = false;

  if (!correo.value) errorCorreo.value = "Introduce tu correo electrónico.";
  else if (!PATRON_CORREO.test(correo.value)) errorCorreo.value = "Ingresa un correo electrónico válido.";

  if (!password.value) errorPassword.value = "Introduce tu contraseña.";

  return !errorCorreo.value && !errorPassword.value;
}

async function autentificarUsuario() {
  if (!validarFormulario()) return;

  contador.value += 1;

  if (contador.value > 3) {
    if (contador.value > 4) return;
    let resc = await api.Cliente.Cliente.HomeApi.SolicitudCambioContrasenia({
      numContrato: "",
      correo: correo.value,
      password: password.value,
      estatus: Core.Enums.EstatusAlta.Recuperacion_Automatica
    } as Core.Models.AltaUsuario);
    $store.agregarToast(resc.data);
    return;
  }

  const res = await api.Cliente.Cliente.HomeApi.Login({
    correo: correo.value,
    contrasenia: password.value
  });
  if (res.data.estado == EstadoRespuesta.OK) {
    gtag("event", "login");
    $router.push({ name: "cliente-cliente-home" });
    store.sesionIniciada = true;
    store.clienteAceptaTerminosCondicionesAvisoPrivacidad = res.data.aceptaTerminosCondicionesAvisoPrivacidad ?? false;
    sessionStorage.setItem("seguirMostrandoBannerCampania", "true");
  } else if (res.data.estado == EstadoRespuesta.INFO) {
    Swal.fire({
      icon: "error",
      showCloseButton: true,
      showConfirmButton: false,
      html: `
            <p class="fw-bold" style="color: #2f2d74; font-size: 14px;"> Estimado cliente:</p>
            <p class="fw-bold" style="color: #2f2d74; font-size: 14px;"> Por el momento no es posible ingresar a tu cuenta.</p>
            <p style="font-size: 12px"> Es importante que te comuniques por cualquiera de los siguientes medios para mayor información:</p>
            <table style="width:100%">
              <tr>
                <td style="width:50%">
                  <p style="font-size: 12px">Correo: <span class="fw-bold" style="color: #2f2d74; font-size: 12px;"> fperez@hircasa.com.mx</span></p>
                </td>
                <td style="width:50%">
                  <p style="font-size: 12px">Domicilio: <span class="fw-bold" style="color: #2f2d74; font-size: 12px;" colspan="2"> Desierto de los Leones No. 46, Nivel 1, Col San Ángel, Alvaro Obregón, CP 01000, Ciudad de México.</span></p>
                </td>
              </tr>
              <tr>
                <td style="width:50%">
                  <p style="font-size: 12px">Teléfono: <span class="fw-bold" style="color: #2f2d74; font-size: 12px;"> 555511 9910 ext. 6277</span></p>
                </td>
                <td></td>
              </tr>
              <tr>
                <td style="width:50%">
                  <p style="font-size: 12px">Whatsapp: <span class="fw-bold" style="color: #2f2d74; font-size: 12px;"> 557665 9885 Opción 3</span></p>
                </td>
                <td style="width:50%">
                  <p style="font-size: 12px">Horario de Atención: <span class="fw-bold" style="color: #2f2d74; font-size: 12px;"> Lunes a Viernes de 09:00 a 18:00 hrs.</span></p>
                </td>
              </tr>
            </table>
            `
    });
  } else {
    // Credenciales rechazadas: el diseño marca ambos campos (Figma 5132:3336).
    correoInvalido.value = true;
    errorPassword.value = "El correo o contraseña son incorrectos.";
    $store.agregarToast(res.data);
  }
}
//#endregion

const res2 = (await api.Cliente.Cliente.HomeApi.Ping()).data;
if (res2) $router.push({ name: "cliente-cliente-home" });
</script>
